import { createSelector } from 'reselect';
import SecurityPhoneNumberSetupStepOrder from '../../constants/security/SecurityPhoneNumberSetupStepOrder';
import RequestStatusTypes from '../../constants/RequestStatusTypes';
import { getSecurityPhoneNumberVerificationRequestStatus } from '../RequestStatusSelector';
import * as SecurityPhoneNumberSetupSteps from '../../constants/security/SecurityPhoneNumberSetupSteps';
import TwoFactorAuthSMSErrors from '../../constants/TwoFactorAuthSMSErrors';
import { getPhoneValidation } from '../ErrorSelector';
export const getSetupStep = state => {
  const {
    setupStepIndex
  } = state.securityPhoneNumberSetup;
  if (setupStepIndex === -1) {
    return SecurityPhoneNumberSetupSteps.UNINITIALIZED;
  }
  return SecurityPhoneNumberSetupStepOrder[state.securityPhoneNumberSetup.setupStepIndex];
};
export const getStagedSMSNumber = state => state.securityPhoneNumberSetup.stagedSMSNumber;
export const getVerificationCodeAttempt = state => state.securityPhoneNumberSetup.verificationCodeAttempt;
export const getVerificationCodeAttemptFailed = state => state.securityPhoneNumberSetup.verificationCodeFailure;
export const getRedirectUrl = state => state.securityPhoneNumberSetup.redirectUrl;
const securityPhoneNumberConfirmedRequestStatusIsPending = createSelector([getSecurityPhoneNumberVerificationRequestStatus], requestStatus => {
  return requestStatus === RequestStatusTypes.PENDING;
});
const isErrorSendingSMS = state => state.securityPhoneNumberSetup.isErrorSendingSMS;
export const getShouldBlockSetupProgress = createSelector([getVerificationCodeAttempt, securityPhoneNumberConfirmedRequestStatusIsPending, getSetupStep, getPhoneValidation, getStagedSMSNumber, isErrorSendingSMS], (verificationCodeAttempt, isPending, setupStep, phoneValidation, stagedSMSNumber, errorSendingSMS) => {
  switch (setupStep) {
    case SecurityPhoneNumberSetupSteps.VERIFY_SMS:
      return verificationCodeAttempt === '';
    case SecurityPhoneNumberSetupSteps.CHANGE_SECURITY_NUMBER:
    case SecurityPhoneNumberSetupSteps.REGISTER_SMS:
      if ([TwoFactorAuthSMSErrors.UNSUPPORTED_COUNTRY, TwoFactorAuthSMSErrors.NOT_VALID_NUMBER].indexOf(phoneValidation) >= 0 || stagedSMSNumber.length < 4) {
        return true;
      }
      if (errorSendingSMS) {
        return true;
      }
      return isPending;
    default:
      return isPending;
  }
});